import {
  AGENCY_PROPERTY_FORM_TOGGLE,
  AGENCY_PROPERTY_FORM_RESET,
  SAVING_AGENCY_PROPERTY,
  SAVED_AGENCY_PROPERTY_SUCCESS,
  SAVED_AGENCY_PROPERTY_FAILURE,
  DELETING_AGENCY_PROPERTY,
  DELETED_AGENCY_PROPERTY_SUCCESS,
  DELETED_AGENCY_PROPERTY_FAILURE,
  AGENCY_PROPERTY_DELETE_RESET
} from '../constants/agencyPropertyFormTypes'

const IDLE = { loading: false, success: null, errors: null, notFound: false }

const INITIAL_STATE = {
  toggle: false,
  agencyPropertyId: null, // null = create mode, an id = edit mode
  formState: IDLE,
  deleteState: IDLE
}

export default function reducer(state = INITIAL_STATE, actions) {
  switch (actions.type) {
    case AGENCY_PROPERTY_FORM_RESET:
      return INITIAL_STATE
    case AGENCY_PROPERTY_FORM_TOGGLE:
      // A newly opened modal never inherits the previous save's errors.
      return {
        ...state,
        toggle: actions.toggle,
        agencyPropertyId: actions.agencyPropertyId,
        formState: IDLE
      }
    case SAVING_AGENCY_PROPERTY:
      return {
        ...state,
        formState: { ...IDLE, loading: true }
      }
    case SAVED_AGENCY_PROPERTY_SUCCESS:
      return {
        ...state,
        formState: { ...IDLE, success: true }
      }
    case SAVED_AGENCY_PROPERTY_FAILURE:
      // `toggle` is left alone, so the modal stays open with the errors.
      return {
        ...state,
        formState: {
          loading: false,
          success: false,
          errors: actions.errors,
          notFound: !!actions.notFound
        }
      }
    case DELETING_AGENCY_PROPERTY:
      return {
        ...state,
        deleteState: { ...IDLE, loading: true }
      }
    case DELETED_AGENCY_PROPERTY_SUCCESS:
      return {
        ...state,
        deleteState: { ...IDLE, success: true }
      }
    case DELETED_AGENCY_PROPERTY_FAILURE:
      return {
        ...state,
        deleteState: {
          loading: false,
          success: false,
          errors: actions.errors,
          notFound: !!actions.notFound
        }
      }
    case AGENCY_PROPERTY_DELETE_RESET:
      // Delete outcomes are cleared on their own: a full reset here would close
      // a modal the operator opened while the delete was in flight.
      return {
        ...state,
        deleteState: IDLE
      }
    default:
      return state
  }
}
